// extracted by mini-css-extract-plugin
export default {"dealerShip":"dealership_dealerShip__j2wa9"};